import { styled } from '@mui/material/styles'
import { useFormContext, useWatch } from 'react-hook-form'
import { useTranslation } from 'react-i18next'
import { useIsFitterSchedulingMode, useScrollElementIntoView } from 'hooks'
import { theme } from 'modules/App/Providers/Theme/theme'
import { AppointmentFormData } from 'types'
import { ErrorMessage } from 'components/forms/ErrorMessage'
import { useSpecialist } from '../../../../../useSpecialist'
import { TIME_SLOT_ANCHOR_SELECTOR } from '../index'

const styles = `
  color: ${theme.palette.grey[600]};
  margin: 0 auto;
  padding: 0;
  font-size: 0.75rem;
  font-weight: 500;
  height: 1rem;
  letter-spacing: 1.25px;
  line-height: 1rem;
  text-align: center;
  text-transform: uppercase;
`
const Container = styled('h3')`
  ${styles}
`
const StyledError = styled(ErrorMessage)`
  ${styles}
  display: block;
`

const name = 'clientStartTime'

type Props = {
  hideSpecialistTime?: boolean
}

const Title = ({ hideSpecialistTime }: Props = { hideSpecialistTime: false }) => {
  const { t } = useTranslation()
  const [clientStartDate, customer_timezone, fitter_timezone, start_date] = useWatch<AppointmentFormData>({
    name: ['clientStartDate', 'customer_timezone', 'fitter_timezone', 'start_date'],
  })

  const {
    formState: { errors },
  } = useFormContext()

  const { specialist } = useSpecialist()
  const isFitterSchedulingMode = useIsFitterSchedulingMode()

  const error = errors?.[name]
  const hasError = Boolean(error)
  const displayText =
    hideSpecialistTime || customer_timezone === fitter_timezone
      ? t('common.label.customerTime')
      : t('common.label.customerSlashSpecialistTitle', { specialistTitle: t(specialist?.title ?? '') })

  const isMissingTimeSelection = Boolean(clientStartDate && !start_date)
  const shouldScrollToTimeSlots = isFitterSchedulingMode && (hasError || isMissingTimeSelection)
  const renderKey = `${clientStartDate ? (clientStartDate as Date).toISOString() : ''}-${hasError}`

  useScrollElementIntoView(TIME_SLOT_ANCHOR_SELECTOR, shouldScrollToTimeSlots, renderKey)

  return <>{hasError ? <StyledError message={displayText} /> : <Container>{displayText}</Container>}</>
}

export { Title }
